import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-reg-application',
    templateUrl: './regApplication.component.html',
    styleUrls: ['./application.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RegApplicationComponent {
    @Input() application: any;

    constructor() {}

}

